import { render, staticRenderFns } from "./pruebaTabla.vue?vue&type=template&id=80ddde08&"
import script from "./pruebaTabla.vue?vue&type=script&lang=js&"
export * from "./pruebaTabla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports